import { render, staticRenderFns } from "./voucherYSYF.vue?vue&type=template&id=49318595&scoped=true&"
import script from "./voucherYSYF.vue?vue&type=script&lang=js&"
export * from "./voucherYSYF.vue?vue&type=script&lang=js&"
import style0 from "./voucherYSYF.vue?vue&type=style&index=0&id=49318595&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49318595",
  null
  
)

export default component.exports